<template>
  <div :class="['tourListHeader_headerArea', content ? '' : '-hidden']">
    <h1
      v-if="content"
      class="tourListHeader_header"
    >
      {{ content }}
    </h1>
  </div>
</template>

<script>
import { SearchCondition } from '@/models'

export default {
  name: 'TourListHeader',
  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
  },
  computed: {
    content() {
      return this.destinationPart || this.departurePlacePart
        ? `${this.destinationPart}${this.departurePlacePart} の格安プラン` : ''
    },
    destinationPart() {
      const primaryCountry = this.condition.primaryDestinationCountry
      const primaryCountryName = primaryCountry ? primaryCountry.country_name_ja : ''
      const concatenatedDestinationCities = this.condition.destinationCities.map(c => c.city_name_ja).join('・')
      if (!primaryCountryName && !concatenatedDestinationCities) return ''

      const countryName = this.condition.isMultiCountry
        ? `${primaryCountryName}ほか`
        : primaryCountryName
      return concatenatedDestinationCities
        ? `${concatenatedDestinationCities}(${countryName})ツアー`
        : `${countryName}ツアー`
    },
    departurePlacePart() {
      return this.condition.departurePlaceName ? `${this.condition.departurePlaceName}発` : ''
    },
  }
}
</script>

<style lang="scss" scoped>
.tourListHeader_headerArea {
  width: 100%;
  max-width: 960px;
  padding: 10px;

  &.-hidden {
    padding: 7px;
  }

  @media (max-width: 657px) {
    max-width: 657px;
    padding: 8px;

    &.-hidden {
      padding: 5px;
    }
  }
}
.tourListHeader_header {
  padding: 3px 0 3px 10px;
  border-left: solid 3px;
  font-size: 16px !important;
  color: #f9423a;
  font-weight: bold;

  @media (max-width: 657px) {
    padding: 2px 0 2px 8px;
    font-size: 12px !important;
    font-weight: normal;
  }
}
</style>
